import { gateway } from "../../../../gateway";

export const getProvidersPagination = async ({ token, page, pageSize }) => {
  try {
    const res = await gateway.get(`/providers/self/?page=${page}&pageSize=${pageSize}`, {
      headers: {
        Authorization: `${token}`,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};
